/**
 * Super Juicy TCG — "Clear cart" behaviour.
 *
 * Empties the cart in one action using Shopify's native Ajax Cart API
 * (/cart/clear.js). No custom cart state; on success we reload so Dawn's
 * cart page / drawer re-render from the now-empty cart.
 *
 * NOTE (2026-07-02): while the `order-minimum` cart_checkout_validation
 * Function still errors on CART_INTERACTION, /cart/clear.js can return 422
 * ("You can't remove this item...") and the cart will NOT clear — the same
 * server-side gate that blocks manual removal below $20. This handler
 * surfaces that server message instead of failing silently. Once the
 * Function skips CART_INTERACTION, clear + manual edits both work.
 */
(function () {
  const cartRoot = () =>
    (typeof window.routes !== 'undefined' && window.routes && window.routes.cart_url) || '/cart';

  class ClearCart extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-clear-cart]');
      this.errorEl = this.querySelector('[data-clear-cart-error]');
      if (this.button) {
        this.button.addEventListener('click', (e) => this.onClick(e));
      }
    }

    async onClick(e) {
      e.preventDefault();
      this.setError('');
      this.button.setAttribute('aria-busy', 'true');
      this.button.disabled = true;

      try {
        const res = await fetch(`${cartRoot()}/clear.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        });

        if (!res.ok) {
          let msg = '';
          try {
            const body = await res.json();
            msg = body.description || body.message || '';
          } catch (_) {
            /* non-JSON error body */
          }
          this.fail(msg);
          return;
        }

        // Cart emptied — reload so Dawn repaints the empty state (page + bubble).
        window.location.reload();
      } catch (_) {
        this.fail('');
      }
    }

    fail(msg) {
      this.button.removeAttribute('aria-busy');
      this.button.disabled = false;
      this.setError(msg || 'Could not clear the cart. Please try again.');
    }

    setError(text) {
      if (this.errorEl) this.errorEl.textContent = text;
    }
  }

  if (!customElements.get('clear-cart')) {
    customElements.define('clear-cart', ClearCart);
  }
})();
